import { render, staticRenderFns } from "./ArquivosEstruturados.vue?vue&type=template&id=6f2df0b0&scoped=true&"
import script from "./ArquivosEstruturados.vue?vue&type=script&lang=js&"
export * from "./ArquivosEstruturados.vue?vue&type=script&lang=js&"
import style0 from "./ArquivosEstruturados.vue?vue&type=style&index=0&id=6f2df0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2df0b0",
  null
  
)

export default component.exports